import React from "react";
import { AiOutlineFilePdf } from "react-icons/ai";
import { cloudFrontUrl } from "../../nestserver";

/** Maps a media item to its CDN folder and normalised type. */
export const getMediaInfo = (item) => {
  let folder = "images";
  let mediaType = item?.type;

  if (item?.type) {
    if (item.type === "IMAGE") folder = "images";
    else if (item.type === "PDF") folder = "pdf";
    else if (item.type === "VIDEO") folder = "video";
    else if (item.type === "AUDIO" || item.type === "VOICE") folder = "audio";
  } else {
    // Older items carry no type; fall back to the file extension.
    const name = item?.name?.toLowerCase() || "";
    if (name.endsWith(".pdf")) {
      folder = "pdf";
      mediaType = "PDF";
    } else if (name.endsWith(".mp4")) {
      folder = "video";
      mediaType = "VIDEO";
    } else if (name.endsWith(".mp3")) {
      folder = "audio";
      mediaType = "AUDIO";
    } else if (name.endsWith(".wav") || name.endsWith(".webm")) {
      folder = "audio";
      mediaType = "VOICE";
    } else if (/\.(jpe?g|png)$/.test(name)) {
      folder = "images";
      mediaType = "IMAGE";
    }
  }
  return { folder, mediaType };
};

const DiaryMedia = ({ item, onImageClick, onVideoClick }) => {
  const { folder, mediaType } = getMediaInfo(item);
  const mediaUrl = `${cloudFrontUrl}/${folder}/${item?.id}`;

  let content;
  if (mediaType === "VIDEO") {
    content = (
      <div
        className="relative cursor-pointer group"
        onClick={() => onVideoClick(mediaUrl)}
      >
        <video
          className="media-video"
          style={{ maxWidth: "100%", borderRadius: "8px", pointerEvents: "none" }}
        >
          <source src={mediaUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors rounded-lg">
          <div className="w-12 h-12 bg-white/80 rounded-full flex items-center justify-center shadow-lg">
            <div className="w-0 h-0 border-l-12 border-l-black border-y-8 border-y-transparent ml-1"></div>
          </div>
        </div>
      </div>
    );
  } else if (mediaType === "AUDIO" || mediaType === "VOICE") {
    content = (
      <div className="flex flex-col items-center">
        <audio
          controls
          className="media-audio w-full min-w-62.5"
          style={{
            width: "100%",
            minWidth: "250px",
            borderRadius: "8px",
            backgroundColor: "#f0f2f5",
            padding: "5px",
          }}
        >
          <source src={mediaUrl} />
          Your browser does not support the audio tag.
        </audio>
        <div
          style={{ fontSize: "12px", marginTop: "4px", wordBreak: "break-all" }}
        >
          {item?.name}
        </div>
      </div>
    );
  } else if (mediaType === "PDF") {
    content = (
      <a
        href={mediaUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="pdf-link"
      >
        <AiOutlineFilePdf size={35} />
        {item?.name}
      </a>
    );
  } else {
    content = (
      <img
        src={mediaUrl}
        alt={item?.name}
        onClick={() => onImageClick(mediaUrl)}
        className="media-image cursor-pointer"
      />
    );
  }

  return <div className="media-container">{content}</div>;
};

export default DiaryMedia;
